// Stable keys reference field names, never array positions or translated labels.
const formDefaults={form_title:'Shipping information',form_subtitle:"Enter your shipping details and we'll arrange delivery.",submit_button_label:'Place COD order',popup_button_label:'Order with cash on delivery',order_total_label:'Total',cod_note_label:'Cash on delivery (COD)'};
const exitDefaults={title:'Wait — your discount is ready',description:'Complete your cash-on-delivery order now and save.',button_label:'Continue my order',dismiss_label:'No thanks'};
const discountDefaults={amount_message:'Add {remaining_amount} more to use {discount_code}.',quantity_message:'Add {remaining_quantity} more item(s) to use {discount_code}.',both_message:'Add {remaining_amount} more and {remaining_quantity} more item(s) to use {discount_code}.'};
export const namespaces=['form','discounts'];
export function contentFields(settings,namespace){
  if(namespace==='form')return [
    ...Object.entries(formDefaults).map(([key,value])=>({key:`style.${key}`,label:key,source:settings.style?.[key]??value,optional:['form_subtitle','cod_note_label'].includes(key)})),
    ...(settings.form_schema||[]).flatMap(field=>(field.name==='product_information'?['label']:['label','placeholder','help_text','required_message']).map(key=>({key:`field.${field.name}.${key}`,label:`${field.label||field.name} · ${key}`,source:field[key]??(key==='required_message'?`Please enter ${field.label||field.name}.`:''),optional:['placeholder','help_text'].includes(key)})))
  ];
  if(namespace==='discounts')return [
    ...Object.entries(exitDefaults).map(([key,value])=>({key:`exit_intent_${key}`,label:key,source:settings[`exit_intent_${key}`]??value,optional:key==='description'})),
    ...Object.entries(discountDefaults).map(([key,value])=>({key:`cod_discount_rules.${key}`,label:key,source:settings.cod_discount_rules?.[key]??value,optional:false}))
  ];
  return [];
}
export function applyContent(settings,namespace,body={}){
  const output=structuredClone(settings);
  for(const field of contentFields(settings,namespace)){
    if(!Object.hasOwn(body,field.key))continue;
    const value=body[field.key];
    if(typeof value!=='string')continue;
    const [group,key,property]=field.key.split('.');
    if(group==='field') {const target=output.form_schema?.find(item=>item.name===key);if(target)target[property]=value;}
    else if(group==='style'||group==='cod_discount_rules') {output[group]??={};output[group][key]=value;}
    else output[group]=value;
  }
  return output;
}
export function canonicalLocale(value){
  if(typeof value!=='string'||value.length>35)return null;
  try{return Intl.getCanonicalLocales(value.replaceAll('_','-'))[0]||null;}catch{return null;}
}
export const tokens=value=>[...String(value).matchAll(/\{([^{}]+)\}/g)].map(match=>match[1]).sort();
export function validateContent(settings,namespace,body){
  const fields=contentFields(settings,namespace),map=new Map(fields.map(field=>[field.key,field]));
  const errors={};
  if(!body||typeof body!=='object'||Array.isArray(body))return {_:'Invalid translation body.'};
  for(const [key,value] of Object.entries(body)){
    const field=map.get(key);
    if(!field){errors[key]='Unknown content field.';continue;}
    if(typeof value!=='string'||value.length>4000){errors[key]='Text must contain at most 4,000 characters.';continue;}
    if(!field.optional&&!value.trim()){errors[key]='This text cannot be hidden.';continue;}
    if(JSON.stringify(tokens(value))!==JSON.stringify(tokens(field.source))||/[{}]/.test(value.replace(/\{[^{}]+\}/g,'')))errors[key]='Keep the same placeholders as the default text.';
  }
  return errors;
}
